module.exports = __webpack_public_path__ + "static/media/maia-monitors.c8384611.svg";